import React, { createContext, useMemo, useCallback, useState, useContext } from 'react';

import PropTypes from 'prop-types';
import { usePersistedState } from '../utils/Common';
import { UserProfileContext } from './UserProfileProvider';

export const CategoryContext = createContext();


export const CategoryProvider = ({ children }) => {
  const { tokenLoaded } = useContext(UserProfileContext);
  const [categoryId,setCategoryId] = usePersistedState('categoryId',undefined);
  const [categoryData,setCategoryData] = usePersistedState('categoryData',undefined);
  const [categoryImages, setCategoryImages] = usePersistedState('categoryImages', {});  
  const [isCategoryFormSubmitted, setIsCategoryFormSubmitted] = useState(false); 
  const [groupedCategoriesByDomain, setGroupedCategoriesByDomain] = useState({}); 
  const [selectCategories, setSelectCategories] = usePersistedState('selectCategories', [],tokenLoaded);
  const clearCartState = useCallback(() => {
    setCategoryId(undefined);  
    setCategoryImages([]);
    setGroupedCategoriesByDomain({});
    setIsCategoryFormSubmitted(false);
    setSelectCategories([]);
     localStorage.removeItem("categoryId");
     localStorage.removeItem("categoryImages");
  }, [setCategoryId, setCategoryImages, setSelectCategories]);

  const value = useMemo(() => ({
   setCategoryId,categoryId,clearCartState,categoryImages,setCategoryImages,isCategoryFormSubmitted,setIsCategoryFormSubmitted,groupedCategoriesByDomain, setGroupedCategoriesByDomain,selectCategories, setSelectCategories,categoryData,setCategoryData
  }), [categoryId, categoryImages, clearCartState, groupedCategoriesByDomain, isCategoryFormSubmitted, selectCategories, setCategoryId, setCategoryImages, setSelectCategories,categoryData,setCategoryData]);

  
  return (
    <CategoryContext.Provider value={value}>
      {children}
    </CategoryContext.Provider>
  );
};
CategoryProvider.propTypes = {
 children: PropTypes.node,
  };
  
  